<template>
  <div>
    <v-card>
      <h1 class="pa-3">DINE-IN STORE USER MANAGEMENT</h1>
      <v-layout row>
        <v-flex xs12>
          <v-toolbar dense flat>
            <v-text-field
              v-model="search"
              prepend-icon="search"
              label="Search"
              single-line
              hide-details
              style="padding: 0"
            ></v-text-field>
          </v-toolbar>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers"
        :loading="is_loading_store"
        :items="filteredDineInStore"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.index + 1 }}</td>
          <td class="text-xs-center" style="padding-block: 10px">
            <v-img :src="props.item.store_image"> </v-img>
          </td>
          <td class="text-xs-center">{{ props.item.store_name_th }}</td>
          <td class="text-xs-center">{{ props.item.store_name_en }}</td>
          <td
            :class="
              props.item.store_connect_user_id.length == 0
                ? `text-xs-center`
                : `text-xs-start`
            "
          >
            <div v-if="props.item.store_connect_user_id.length == 0">-</div>
            <div
              v-else
              v-for="item in props.item.store_connect_user_id"
              :key="item.title"
            >
              <li>{{ item.user_first_name }} {{ item.user_last_name }}</li>
            </div>
          </td>
          <td class="text-xs-center">
            {{
              moment(props.item.store_update_at).format(
                "MMMM Do YYYY, HH:mm:ss"
              )
            }}
          </td>
          <td class="text-xs-center">
            <v-btn
              fab
              class="elevation-0"
              small
              color="primary"
              @click="
                dialog = true;

                selected_item = props.item;
              "
              ><v-icon color="black">edit</v-icon></v-btn
            >
          </td>
        </template>

        <template slot="no-data">
          <div class="text-xs-center" v-if="is_loading_store == false">
            No data available
          </div>
          <div class="text-xs-center" v-else>
            <v-progress-circular
              :size="30"
              color="primary"
              indeterminate
            ></v-progress-circular>
            {{ "Loading data ..." }}
          </div>
        </template>
      </v-data-table>
    </v-card>
    <SelectUserMerchantModal
      :dialog="dialog"
      @closeDialog="closeDialog()"
      :selected="selected_item"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import SelectUserMerchantModal from "../../../../components/back-office/Merchant/StoreUserMerchant/SelectUserMerchantModal.vue";
export default {
  components: { SelectUserMerchantModal },
  data: () => ({
    search: "",
    dialog: false,
    selected_item: {},
    is_loading_store: false,
    pagination: {
      rowsPerPage: 10,
      page: 1,
      totalItems: 0,
    },
    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
      },
      {
        text: "Store Image",
        align: "center",
        value: "store_image",
        sortable: false,
      },
      {
        text: "Store Name TH",
        align: "center",
        value: "store_name_th",
        sortable: false,
      },
      {
        text: "Store Name EN",
        align: "center",
        value: "store_name_en",
        sortable: false,
      },
      {
        text: "User Owner",
        align: "center",
        value: "store_connect_user_id",
        sortable: false,
      },
      {
        text: "Last Updated",
        align: "center",
        value: "store_update_at",
        sortable: false,
      },
      {
        text: "Action",
        align: "center",
        sortable: false,
      },
    ],
  }),
  component: { SelectUserMerchantModal },
  computed: {
    ...mapState({
      dine_in_store_list: (state) =>
        state.fetchStoreApproveBack.dine_in_store_list,
    }),
    ...mapGetters(["isEditStoreApprove"]),
    pages() {
      if (this.length != 0) {
        this.pagination.totalItems = this.dine_in_store_list.length;
      }
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    filteredDineInStore() {
      return this.dine_in_store_list.filter((val) => {
        return (
          val.store_name_th.toLowerCase().includes(this.search.toLowerCase()) ||
          val.store_name_en.toLowerCase().includes(this.search.toLowerCase()) ||
          val.store_connect_user_id.some((val2) => {
            return val2.user_first_name
              .toLowerCase()
              .includes(this.search.toLowerCase());
          })
        );
      });
    },
  },
  created() {
    this.fetchData();
  },

  methods: {
    moment,
    initial() {
      this.fetchData();
    },

    async closeDialog() {
      this.dialog = false;
    },
    async fetchData() {
      this.is_loading_store = true;
      await this.$store.dispatch("fetchStoreApproveBack/getDineInStoreList");
      this.is_loading_store = false;
    },
  },
};
</script>


